import { ReactNode, FC } from "react";
import { Person } from "@mui/icons-material";
import { WorkforceDetail } from "../../../employees/components/WorkforceDetail";
import { ClientDetailsTabs } from "../../../clients/ClientDetailsModal/ClientDetailsTabs";
import { colors } from "../../../ui/colors";

interface IModalConfig {
  key: string;
  label: string;
  icon: ReactNode;
  defaultSizes?: { width: number; height: number };
  component: FC<any>;
  tooltip?: string;
  props?: any;
}

interface IModals {
  [modalName: string]: IModalConfig;
}

export function useCallModals(callerType: string, caller: any | null) {
  const modals: IModals = {};

  if (!caller) return { modals };

  if (callerType === "workforce") {
    modals.contactInfo = {
      key: "Call-Modal-ContactInfo",
      label: "Contact Info",
      icon: <Person sx={{ color: colors.orange.base }} />,
      tooltip: "View workforce details",
      component: WorkforceDetail,
      props: {
        workforce: caller,
      },
    };
  }

  if (callerType === "client") {
    modals.contactInfo = {
      key: "Call-Modal-ContactInfo-Client",
      label: "Contact Info",
      icon: <Person sx={{ color: colors.orange.base }} />,
      tooltip: "View client details",
      component: ClientDetailsTabs,
      props: {
        client: caller
      }
    };
  }

  return { modals };
}
